import SidebarBottomContent from './SidebarBottomContent.js';

export default SidebarBottomContent;
